// extracted by mini-css-extract-plugin
export default {"secondary_btn":"index_secondary_btn__45-c6"};